import { cn } from "@/lib/utils";

const Loader = ({ className }: { className?: string }) => {
  return (
    <div className="container flex min-h-[calc(100vh-80px)] items-center justify-center lg:min-h-[calc(100vh-120px)]">
      <div
        className={cn(
          "h-16 w-16 animate-spin rounded-full border-t-2 border-b-2 border-blue-500",
          className
        )}
      ></div>
    </div>
  );
};

export default Loader;
